{
    "ControlsAgentButtonTitle": "Show all of the available controls for the agent",
    "ControlsDeviceButtonTitle": "Show all of the available controls for the device",
    "NAME": "StaticAgentControls"
}